<template>
  <div v-if="certInfo.length" class="wrapper">
    <div v-if="pdfUrl" class="pdf-content">
      <div v-for="(page, index) in pageTotal" :key="index">
        <canvas :id="`theCanvas${index}`" class="_canvas" />
      </div>
    </div>

    <empty
      v-else
      :desc="'暂无报告'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
  </div>
</template>
<script>
import PDFJS from 'pdfjs-dist/es5/build/pdf'
import pdfjsWorker from 'pdfjs-dist/es5/build/pdf.worker.entry'
import Empty from '@/common/layout/empty/index'
export default {
  components: {
    Empty
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    certInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pageTotal: 0
    }
  },
  computed: {
    pdfUrl() {
      const obj = this.certInfo[this.activeIndex]
      return obj && obj.cert && obj.cert.length ? obj.cert[0] : '' // 只取第一个pdf
    }
  },

  mounted() {
    const _this = this
    const loadingTask = PDFJS.getDocument(this.pdfUrl)
    PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker // `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS.version}/pdf.worker.js`
    loadingTask.promise
      .then(function (pdfDocument) {
        const numPages = pdfDocument.numPages
        _this.pageTotal = numPages
        for (let i = 0; i < numPages; i++) {
          _this.drawPage(pdfDocument, i)
        }
      })
      .catch(function (reason) {
        console.error('Error: ' + reason)
      })
  },

  methods: {
    drawPage(pdfDocument, page) {
      return pdfDocument.getPage(page + 1).then(function (pdfPage) {
        // Display page on the existing canvas with 100% scale.
        const viewport = pdfPage.getViewport({ scale: 1.0 })
        const canvas = document.getElementById('theCanvas' + page)

        canvas.width = viewport.width
        canvas.height = viewport.height
        const ctx = canvas.getContext('2d')
        const renderTask = pdfPage.render({
          canvasContext: ctx,
          viewport: viewport
        })
        return renderTask.promise
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;

  flex: 1;

  flex-direction: column;
}
.empty-content {
  background-color: #fff;

  flex: 1;

  @include flex-column-center;
  & > .empty {
    width: 3rem;
  }
}

.pdf-content {
  display: flex;

  height: 0;

  background: #fff;

  flex: 1;
  flex-direction: column;
}

._canvas {
  width: 100%;
  max-height: 100%;
}

.expand {
  transform: scale(2);
  transform-origin: 0 0;
}
</style>
